export default __webpack_public_path__ + "static/media/photo7.5fc0f44e.jpg";